import type { AirportType } from './types';

export const isUnserved = (
  origin: AirportType | Record<string, never>,
  destination: AirportType | Record<string, never>,
): boolean => !!(origin.iata_code && origin.unserved.includes(destination.iata_code));

export const isConnected = (
  origin: AirportType | Record<string, never>,
  destination: AirportType | Record<string, never>,
): boolean => !!(origin.iata_code && origin.connected.includes(destination.iata_code));

export const isNonstop = (
  origin: AirportType | Record<string, never>,
  destination: AirportType | Record<string, never>,
): boolean => !!(origin.iata_code && origin.nonstop.includes(destination.iata_code));
